import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * URL de la photo de profil d'un utilisateur, ou null s'il n'en a pas.
 * Usage : <img *ngIf="user | userPhotoUrl as url; else picto" [src]="url">
 */
@Pipe({
  name: 'userPhotoUrl',
  standalone: true
})
export class UserPhotoUrlPipe implements PipeTransform {
  transform(user: { photo?: string | null } | null | undefined): string | null {
    return user?.photo ? environment.apiUrl + '/user-photo/' + user.photo : null;
  }
}
